import { Injectable } from "@angular/core";
import moment from "moment";


@Injectable()
export class FileUtility {
  static jsonString: string;
  static columnList: any;

  static convertToCSV(objArray, columnList) {
  let jsonString = JSON.stringify(objArray)
    .replace(/\\n/g, ' ')
    .replace(/\\t/g, ' ')
    .replace(/\\r/g, ' ');

  const array = JSON.parse(jsonString);
  let str = '';
  let row = 'sep=|\n';

  // Header Row
  columnList.forEach(element => {
    if (element.value.toLowerCase().includes('date')) {
      row += `${element.value} Date|${element.value} Time|`;
    } else {
      row += `${element.value}|`;
    }
  });
  str += row + '\r\n';

  // Data Rows
  array.forEach(item => {
    let line = '';
    columnList.forEach(element => {
      const key = element.key;
      const header = element.value;

      let value = item[key];

      // Handle date columns
      if (header.toLowerCase().includes('date')) {
        if (value) {
          let dateTime = moment.utc(value.replace('T', ' ')).local().format('YYYY/MM/DD HH:mm:ss');
          const [date, time] = dateTime.split(' ');
          line += (date === '0001/01/01' ? 'NA' : date) + '|';
          line += (date === '0001/01/01' ? 'NA' : time) + '|';
        } else {
          line += 'NA|NA|';
        }
      }

      // Handle documents
      else if (header.toLowerCase().includes('documents')) {
        if (value) {
          line += `=HYPERLINK("${value}")|`;
        } else {
          line += 'NA|';
        }
      }

      // Handle priority formatting
      else if (header === 'Priority') {
        line += FileUtility.changePriorityFormat(value) + '|';
      }

      // Handle ID override if draft
      else if (header === 'ID') {
        line += item.Status === 'Draft' ? 'Draft|' : value + '|';
      }

      // Handle nested properties (e.g., key = "object.property")
      else if (key.includes('.')) {
        const [objKey, propKey] = key.split('.');
        const nestedObj = item[objKey];
        if (nestedObj && nestedObj[propKey] !== undefined) {
          line += nestedObj[propKey] + '|';
        } else {
          line += 'NA|';
        }
      }

      // Regular value
      else {
        if (value === undefined || value === null) {
          line += 'NA|';
        } else {
          let valStr = value.toString();
          valStr = FileUtility.hascommas(valStr) && header !== 'InspectorFullName'
            ? valStr.replace(/,/g, '-')
            : valStr;
          valStr = FileUtility.hasArithmeticOperators(valStr)
            ? ` ${valStr}`
            : valStr;
          line += valStr + '|';
        }
      }
    });

    str += line + '\r\n';
  });

  return str;
}

  static downloadCSV(parsedResponse, fileDownLoadName) {

    const blob = new Blob([parsedResponse], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = url;
      a.download = fileDownLoadName;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }

  static downloadPDF(parsedResponse,fileDownLoadName) {
    var data = parsedResponse;
    var contentType = 'application/octet-stream';
    var ieEDGE = navigator.userAgent.match(/Edge/g);
    var ie = navigator.userAgent.match(/.NET/g);
    // IE 11+
    var oldIE = navigator.userAgent.match(/MSIE/g);
    var blob = new window.Blob([data], {
      type: contentType
    });
      var file = new Blob([data], {
        type: contentType
      });
      var fileURL = URL.createObjectURL(file);
      var a = document.createElement('a');
      a.href = fileURL;
      a.target = '_blank';
      a.download = fileDownLoadName;
      document.body.appendChild(a);
      a.click();
  }

  static changePriorityFormat(priorityToFormat) {
    let strPriority = null;
    switch (priorityToFormat) {
      case 3:
        strPriority = 'High';
        break;
      case 2:
        strPriority = 'Medium';
        break;
      case 1:
        strPriority = 'Low';
        break;
    }
    return strPriority;
  }

  static hasArithmeticOperators(str): boolean {
    return /[\+\-\*\/]/g.test(str);
    }

  static hascommas(str): boolean {
    return /[,]/g.test(str);
    } 
}
